<mat-toolbar class="topbar">
  <app-branding></app-branding>

  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  <button mat-icon-button (click)="toggleCollapsed.emit()" *ngIf="showToggle" class="d-flex justify-content-center">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>

  <!-- Mobile Menu -->
  <button mat-icon-button (click)="toggleMobileNav.emit()" *ngIf="!showToggle" class="d-flex justify-content-center">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  <!-- --------------------------------------------------------------- -->

  <!-- --------------------------------------------------------------- -->
  <!--  Search -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button
    mat-icon-button
    (click)="openDialog()"
    class="d-flex justify-content-center"
  >
    <i-tabler name="search" class="icon-20 d-flex"></i-tabler>
  </button> -->

  <span class="flex-1-auto"></span>

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5">
    <img [src]="selectedLanguage.icon" class="rounded object-cover icon-20" />
  </button>
  <mat-menu #flags="matMenu" class="cardWithShadow">
    <button
      mat-menu-item
      *ngFor="let lang of languages"
      (click)="changeLanguage(lang)"
    >
      <div class="d-flex align-items-center">
        <img [src]="lang.icon" class="rounded object-cover m-r-8 icon-20" />
        <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
      </div>
    </button>
  </mat-menu> -->

  <!-- SELEZIONE SITE -->
  <mat-select *ngIf="showSiteSelect && userLevel === 'Sito'" class="p-x-10 p-y-6 m-x-10 bg-white"
    [(value)]="selectedSite" style="width: 15%;" placeholder="Seleziona una site">
    <mat-option>Seleziona un site</mat-option>
    <mat-option *ngFor="let site of siteList" [value]="site.id" (click)="changeSite(site.id)">{{ site.description
      }}</mat-option>
  </mat-select>
  <!-- SELEZIONE CER -->
  <mat-select *ngIf="showCerSelect && userLevel !== 'Sito'" class="p-x-10 p-y-6 bg-white" [(value)]="selectedCer"
    style="width: 15%;" placeholder="Seleziona una CER">
    <mat-option>Seleziona una CER</mat-option>
    <mat-option *ngFor="let cer of cerList" [value]="cer.id" (click)="changeCer(cer.id)">{{
      cer.description}}</mat-option>
  </mat-select>

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="notificationmenu" aria-label="Notifications">
    <mat-icon matBadge="1" matBadgeOverlap="false" matBadgeColor="warn" class="header-badge">message</mat-icon>
  </button>
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0">Notifications</h6>
      <span class="m-l-auto">
        <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">5 new</span>
      </span>
    </div>
    <button mat-menu-item class="p-x-32 p-y-16" *ngFor="let notification of notifications">
      <div class="d-flex align-items-center">
        <img [src]="notification.img" class="rounded-circle" width="48" />
        <div class="m-l-16">
          <h5 class="f-s-14 f-w-600 m-0 mat-subtitle-1">
            {{ notification.title }}
          </h5>
          <span>{{ notification.subtitle }}</span>
        </div>
      </div>
    </button>
    <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100">
        See all notifications
      </button>
    </div>
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- Messages Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="msgmenu" aria-label="Messages">
    <mat-icon matBadge="2" matBadgeOverlap="false" matBadgeColor="warn" class="header-badge">email</mat-icon>
  </button>
  <mat-menu #msgmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0">Messages</h6>
      <span class="m-l-auto">
        <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">5 new</span>
      </span>
    </div>
    <button mat-menu-item class="p-x-32 p-y-16" *ngFor="let msg of msgs">
      <div class="d-flex align-items-center">
        <img [src]="msg.img" class="rounded-circle" width="48" />
        <div class="m-l-16">
          <h5 class="f-s-14 f-w-600 m-0 mat-subtitle-1">
            {{ msg.title }}
          </h5>
          <span>{{ msg.subtitle }}</span>
        </div>
      </div>
    </button>
    <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100">
        See all messages
      </button>
    </div>
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications">
    <img src="/assets/images/profile/blank.png" class="rounded-circle object-cover" width="35" />
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <ng-scrollbar class="position-relative" style="height: 450px">
      <div class="p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0">Profilo utente</h6>

        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          <i-tabler name="user-circle" class="icon-50 d-flex"></i-tabler>
          <!-- <img src="/assets/images/profile/profile.png" class="rounded-circle" width="95" /> -->
          <div class="m-l-16">
            <h6 class="f-s-14 f-w-600 m-0">{{ userFullName }}</h6>
            <span class="d-flex align-items-center">
              <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
              {{ userEmail }}
            </span>
          </div>
        </div>
      </div>
      <div class="p-x-32">
        <a class="p-y-16 text-decoration-none d-block text-hover-primary" [routerLink]="[profile.link]"
          *ngFor="let profile of profiledd">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
              <img [src]="profile.img" width="20" />
            </button>

            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                {{ profile.title }}
              </h5>
              <span class="mat-body-1">{{ profile.subtitle }}</span>
            </div>
          </div>
        </a>
      </div>

      <div class="p-y-12 p-x-32">
        <a (click)="logout()" mat-stroked-button color="primary" class="w-100">Logout</a>
      </div>
    </ng-scrollbar>
  </mat-menu>
</mat-toolbar>